/// <reference path="../public/jquery-1.6.2.min.js" />
/// <reference path="../public/AJAX.js" />
/// <reference path="../public/General.js" />
/// <reference path="../public/Security.js" />
/// <reference path="../public/ServiceURL.js" />
/// <reference path="../SumoDataAccess.js" />
/// <reference path="../SumoClass.js" />

///////////////////////////////////////////////////////////////////////////////////////////////////////
// ExpirableCacheItem
///////////////////////////////////////////////////////////////////////////////////////////////////////

function ExpirableCacheItem(aData,
                            aItemName,
                            aExpirationTimespan,
                            aIsFloatingExpiration,
                            aOnExpireEvent) {
    "use strict";

    this.Data = aData;
    this.Name = aItemName;
    this.ExpirationTimeSpan = aExpirationTimespan;
    this.IsFloatingExpiration = aIsFloatingExpiration;
    this.OnExpireEvent = aOnExpireEvent;

    this.Locked = false;
    this.ExpirationTimeoutId = null;

    this.Expire = function () {
        if (this.OnExpireEvent !== null) {
            this.OnExpireEvent(this);
        }
    };
}

///////////////////////////////////////////////////////////////////////////////////////////////////////
// UpdatableCacheItem
///////////////////////////////////////////////////////////////////////////////////////////////////////
function UpdatableCacheItem(aItemName,
                            aTypeName,
                            aExpression,
                            aUpdateIntervalInSeconds,
                            aUpdateFailureCallback,
                            aParams,
                            aUpdatedCallback,
                            aCache,
                            aDoFixDates,
                            aHashIndexColumns,
                            aNonCacheble,
                            aNonCacheExpression) {
    "use strict";

    var self = this,
        mIsLocked = false,
        mLockOwner = null,
        mUpdatedCallback = aUpdatedCallback,
        mUpdateFailureCallback = aUpdateFailureCallback,
        mCache = aCache,
        mStatistics = [],
        mHashIndexColumns = null;

    this.Name = aItemName;
    this.TypeName = aTypeName;
    this.Expression = aExpression;
    this.Params = aParams;
    this.DoFixDates = true;
    this.NonCached = aNonCacheble;
    this.NonCachedExpression = aNonCacheExpression;

    this.UpdateIntervalInSeconds = aUpdateIntervalInSeconds;
    this.Data = null;
    this.Version = 0;
    this.UpdateIntervalId = null;
    // this.OnUpdateSuccessEvent = aOnUpdateSuccessEvent;
    // this.OnUpdateFailureEvent = aOnUpdateFailureEvent;

    if (!isNullOrUndefined(aDoFixDates)) {
        this.DoFixDates = aDoFixDates;
    }

    if (!isNullOrUndefined(aHashIndexColumns)) {
        mHashIndexColumns = aHashIndexColumns;
    }

    this.getHashValue = function (aDataItem) {
        var lResult = null,
            i,
            lHashIndexColumnsLength = 0,
            lHashList = null;

        if (mHashIndexColumns !== null) {
            lHashList = [];
            lHashIndexColumnsLength = mHashIndexColumns.length;
            for (i = 0; i < lHashIndexColumnsLength; i++) {
                lHashList.push(aDataItem[mHashIndexColumns[i]]);
                lHashList.push('.');
            }
            lResult = lHashList.join('');
        } else {
            lResult = aDataItem.Id;
        }
        return lResult;
    };

    this.runExpression = function () {
        self.Data = query(self.Data, self.Expression);
    };

    function setVersion(aNewData) {
        var lIsChanged = false;
        if (!isNullOrUndefined(aNewData)) {
            if (aNewData instanceof Array) {
                var lMaxVersion = self.Version,
                    i;
                for (i = 0; i < aNewData.length; i++) {
                    if (typeof aNewData[i].Version === 'undefined') {
                        break; // if the first item is unversioned, so will the rest be
                    }
                    if (aNewData[i].Version > lMaxVersion) {
                        lMaxVersion = aNewData[i].Version;
                        lIsChanged = true;
                    }
                }
                self.Version = lMaxVersion;
            } else {
                if (typeof aNewData.Version !== 'undefined') {
                    self.Version = aNewData.Version;
                    lIsChanged = true;
                }
            }
        }
        return lIsChanged;
    }

    function assignAllData(aNewData) {
        self.Data = {};
        var i;
        if (aNewData instanceof Array) {
            if (self.DoFixDates) {
                FixDates(aNewData);
            }
            for (i = 0; i < aNewData.length; i++) {
                var lItem = aNewData[i];
                //self.Data[lItem.Id] = lItem;
                self.Data[self.getHashValue(lItem)] = lItem;
            }
        }
        else {
            self.Data = aNewData;
            }

        return setVersion(aNewData);
    }

    function synchronizeData(aNewData) {
        var lIsChanged = false;
        if (!isNullOrUndefined(aNewData)) {
            if (null === self.Data) {
                // data never set before, go setup the hash
                lIsChanged = assignAllData(aNewData);
            } else if (aNewData instanceof Array) {
                if (self.DoFixDates) {
                    FixDates(aNewData);
                }
                // loop inbound data
                var i;
                for (i = 0; i < aNewData.length; i++) {
                    var lNewItem = aNewData[i],
                        lOldItem = self.Data[self.getHashValue(lNewItem)],
                        lNewItemHasVersion,
                        lOldItemHasVersion,
                        lIsOldItemDefined = typeof lOldItem !== 'undefined';

                    lNewItemHasVersion = typeof lNewItem.Version !== 'undefined';
                    lOldItemHasVersion = lIsOldItemDefined && typeof lOldItem.Version !== 'undefined';

                    if ((!lIsOldItemDefined) ||
                            (!lNewItemHasVersion && !lOldItemHasVersion) ||
                            (lNewItem.Version > lOldItem.Version)) {
                        // self.Data[lNewItem.Id] = lNewItem;
                        self.Data[self.getHashValue(lNewItem)] = lNewItem;
                    }
                }
                self.runExpression();
            } else {
                // inbound data isn't an array
                if ((typeof aNewData.Version === 'undefined') || (aNewData.Version > self.Data.Version)) {
                    self.Data = aNewData;
                }
            }
            // method must be first or data is never set
            lIsChanged = (setVersion(aNewData) || lIsChanged);
        }
        return lIsChanged;
    }

    function acquireAjaxLock(aLockOwner) {
        var lResult = !mIsLocked;
        if (lResult) {
            mIsLocked = true;
            mLockOwner = aLockOwner;
        }
        return lResult;
    }

    function releaseAjaxLock(aLockOwner) {
        if (mLockOwner === aLockOwner) {
            mIsLocked = false;
            mLockOwner = null;
        }
    }

    function updateSuccessCallback(aParams, aData) {
        var lPreviousVersion = self.Version,
            lIsChanged = (lPreviousVersion === 0),
            lItem,
            lKey,
            lStopTime,
            lSpan;
        // method must be first or data is never set
        lIsChanged = (synchronizeData(aData) || lIsChanged);
        releaseAjaxLock('this.Update');

        lStopTime = new Date();
        lSpan = lStopTime - aParams.startTime;
        mStatistics[aParams.startTime.getTime()] = { 'timeSpan': lSpan, 'itemCount': aData.length };

        mCache.trigger(self.Name + 'complete', self);
        if (mUpdatedCallback !== null && lIsChanged) {
            mUpdatedCallback(self);
        }
    }

    function updateFailureCallback(aParams, aXmlHttpRequest, aTextStatus, aErrorThrown) {
        releaseAjaxLock('this.Update');
        if (!isNullOrUndefined(mUpdateFailureCallback)) {
            mUpdateFailureCallback(self, aXmlHttpRequest, aTextStatus, aErrorThrown, aParams);
        }
    }

    function fetchData() {
        var lStart = new Date();          
        if (self.NonCached && self.NonCachedExpression){
            GetNonCacheItem("Get" + self.Name, self.NonCachedExpression, updateSuccessCallback, updateFailureCallback, { 'startTime': lStart });
        } else {
            ReadMultiple(self.TypeName,
                self.Expression,
                self.Version,
                updateSuccessCallback,
                updateFailureCallback,
                { 'startTime': lStart },
                null,
                0,
                false);
        }       
    }

    this.Update = function () {
        if (acquireAjaxLock('this.Update')) {
            fetchData();
        }
    };

    this.getStatistics = function () {
        return mStatistics;
    };

}



// here's how to do function with string instead of function pointer
//window[lFnName](source, args);

///////////////////////////////////////////////////////////////////////////////////////////////////////
// Cache
///////////////////////////////////////////////////////////////////////////////////////////////////////
function Cache() {
    "use strict";

    Cache.prototype.baseClass.call(this);

    var self = this,
        mExpirableItems = {},
        mUpdatableItems = {};

    function initializeUpdateTimer(aCacheItem) {
        aCacheItem.UpdateIntervalId = window.setInterval(function () { aCacheItem.Update(); }, aCacheItem.UpdateIntervalInSeconds * 1000);
    }

    function initializeExpirationTimer(aCacheItem) {
        aCacheItem.ExpirationTimeoutId = window.setTimeout(function () { self.ExpireItem(aCacheItem.Name); }, aCacheItem.ExpirationTimeSpan * 1000);
    }

    function onItemUpdate(aItem) {
        self.trigger(aItem.Name + 'updated', aItem);
    }

    this.GetItem = function (aItemName) {
        var lResult = mExpirableItems[aItemName];
        if (this.isNothing(lResult)) {
            lResult = mUpdatableItems[aItemName];
        }
        return lResult;
    };

    this.RemoveItem = function (aItemName) {
        var lResult = this.RemoveExpirableItem(aItemName);
        if (this.isNothing(lResult)) {
            lResult = this.RemoveUpdatableItem(aItemName);
        }
        return lResult;
    };

    this.AddUpdatableItem = function (aItemName,
                                      aTypeName,
                                      aExpression,
                                      aUpdateIntervalInSeconds,
                                      aUpdateFailureCallback,
                                      aParams,
                                      aDoFixDates,
                                      aHashIndexColumns,
                                      aNonCached,
                                      aNonCachedExpression) {

        var lCacheItem = new UpdatableCacheItem(aItemName,
                                                aTypeName,
                                                aExpression,
                                                aUpdateIntervalInSeconds,
                                                aUpdateFailureCallback,
                                                aParams,
                                                onItemUpdate,
                                                this,
                                                aDoFixDates,
                                                aHashIndexColumns,
                                                aNonCached,
                                                aNonCachedExpression);

        mUpdatableItems[aItemName] = lCacheItem;
        this.trigger(aItemName + 'added', lCacheItem);

        // get the data now
        lCacheItem.Update();
        // set up the fetch loop
        // initializeUpdateTimer(lCacheItem);
        setTimeout(function () { initializeUpdateTimer(lCacheItem); }, Math.floor((Math.random() * 60) + 1) * 1000);

        return lCacheItem;
    };

    this.GetUpdatableItem = function (aItemName) {
        return mUpdatableItems[aItemName];
    };

    this.RemoveUpdatableItem = function (aItemName) {
        var lResult = mUpdatableItems[aItemName];
        if (!this.isNothing(lResult)) {
            window.clearInterval(lResult.UpdateIntervalId);
            mUpdatableItems[aItemName] = null;
        }
        return lResult;
    };

    this.AddExpirableItem = function (aData,
                                      aItemName,
                                      aExpirationTimespan,
                                      aIsFloatingExpiration,
                                      aOnExpireEvent) {

        var lIsFloatingExpiration = (aExpirationTimespan !== 0 && aIsFloatingExpiration),
            lCacheItem = new ExpirableCacheItem(
            aData,
            aItemName,
            aExpirationTimespan,
            lIsFloatingExpiration,
            aOnExpireEvent);

        mExpirableItems[aItemName] = lCacheItem;
        this.trigger(aItemName + 'added', lCacheItem);
        if (aExpirationTimespan !== 0) {
            initializeExpirationTimer(lCacheItem);
        }
        return lCacheItem;
    };

    this.GetExpirableItem = function (aItemName) {
        var lResult = mExpirableItems[aItemName];
        if (!this.isNothing(lResult) && lResult.IsFloatingExpiration) {
            window.clearTimeout(lResult.ExpirationTimeoutId);
            initializeExpirationTimer(lResult);
        }
        return lResult;
    };

    this.RemoveExpirableItem = function (aItemName) {
        var lResult = mExpirableItems[aItemName];
        if (!this.isNothing(lResult)) {
            window.clearTimeout(lResult.ExpirationTimeoutId);
            mExpirableItems[aItemName] = null;
        }
        return lResult;
    };

    this.ExpireItem = function (aItemName) {
        var lCacheItem = this.RemoveExpirableItem(aItemName);
        if (!this.isNothing(lCacheItem)) {
            lCacheItem.Expire();
            lCacheItem.Data = null;
            lCacheItem = null;
        }
    };

    this.UpdateItem = function (aItemName) {
        var lCacheItem = mUpdatableItems[aItemName];
        if (!this.isNothing(lCacheItem)) {
            lCacheItem.Update();
        }
    };

    this.getUpdatableItems = function () {
        return mUpdatableItems;
    };
}

Cache.prototype = new sumo.Class();
Cache.prototype.constructor = Cache;
Cache.prototype.baseClass = sumo.Class;
